import { PageComponent } from '@root/pages/Type';
import { MethodRecordItem } from '../Types';
import Loading from './Loading';
import styles from './Macro.module.scss';
import Methods, { MacroMethodsProps } from './Methods';

export type MethodsContainerProps = Omit<MacroMethodsProps, 'methods'> & {
    methods: MethodRecordItem[];
    isLoading: boolean;
};

const MethodsContainer: PageComponent<MethodsContainerProps> = ({
    isLoading,
    ...props
}) => {
    if (isLoading) {
        return (
            <div
                className={`row ${styles.smart_chooser_container}`}
                data-one-input-smart="true"
                data-name="period"
            >
                <Loading />
            </div>
        );
    }
    return (
        <div
            className={`row ${styles.smart_chooser_container}`}
            data-one-input-smart="true"
            data-name="period"
        >
            <Methods {...props} />
        </div>
    );
};

export default MethodsContainer;
